import { CSSProperties, FC, useMemo, useRef } from 'react'
import cn from './common.module.css'
import classNames from 'classnames'
import { QRCodeSVG } from 'qrcode.react'
import { useSelector } from 'react-redux'
import { toBlob } from 'html-to-image'
import { useAddAlert } from '@/hooks/useAddAlert'

interface IHorizontalProfileQRCard {
  user?: IUser
  classname?: string
  style?: CSSProperties
}

const HorizontalProfileQRCard: FC<IHorizontalProfileQRCard> = ({
  user,
  classname,
  style,
}) => {
  const addAlert = useAddAlert()
  const ref = useRef<HTMLDivElement | null>(null)

  const settings = useSelector((store: any) => {
    return {
      icon: store?.settings?.mainLogo ?? '',
      profile: store?.profile?.profile ?? null,
    }
  })

  const { value, profile } = useMemo(() => {
    const baseUrl = window.location.origin
    const profile = (user ?? settings?.profile ?? null) as IUser | null

    return {
      value: `${baseUrl}/profile-view?id=${profile?.id}`,
      profile: profile,
    }
  }, [settings, user])

  const copyQRToClipboard = async () => {
    if (!ref.current) return

    try {
      const blob = await toBlob(ref.current, {
        backgroundColor: 'var(--color-surface)',
        quality: 1,
        canvasWidth: 480,
        canvasHeight: 480,
        cacheBust: true,
      })

      if (!blob) throw new Error('Blob generation failed')

      const data = [new ClipboardItem({ [blob.type]: blob })]
      await navigator.clipboard.write(data)

      console.log('Изображение скопировано!')
      addAlert({ title: 'QR-код скопирован' })
    } catch (error) {
      console.error('Ошибка копирования:', error)
      addAlert({ title: 'Ошибка копирования', text: error })
    }
  }

  return (
    <button
      className={classNames(cn.horizontalWrapper, classname)}
      style={style}
      onClick={copyQRToClipboard}
    >
      <div className={cn.info}>
        <div className={cn.infoTitle}>{profile?.name}</div>
        <div className={cn.infoDescription}>
          Поделитесь этим QR-кодом, чтобы другие могли быстро открыть ваш
          профиль.
        </div>
      </div>
      <div ref={ref}>
        <QRCodeSVG
          value={value}
          bgColor="#ffffff"
          fgColor="#2b2d3e"
          size={84}
          level="Q"
          // imageSettings={{
          //   src: process.env.REACT_APP_PATH_FILE + settings?.icon,
          //   x: undefined,
          //   y: undefined,
          //   height: 24,
          //   width: 24,
          //   opacity: 1,
          //   excavate: true,
          // }}
        />
      </div>
    </button>
  )
}

export default HorizontalProfileQRCard
